<div class="card mt-3">
  <div class="card-header">
    <i class="fa fa-calendar"></i> Periods
  </div>
  <div class="card-body">
    <div class="mb-3">
      <button class="btn btn-sm btn-primary" type="button" (click)="onClickAdd()">
        <i class="fa fa-plus"></i> Add Period
      </button>
    </div>
    <table class="table table-responsive-sm table-hover table-outline mb-0">
      <thead class="thead-light">
        <tr>
          <th>#</th>
          <th>ID</th>
          <th>Name</th>
          <th>Collection</th>
          <th>Start Date</th>
          <th>End Date</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        @if (isLoading) {
          <tr>
            <td colspan="8" class="text-center">
              <span class="spinner-border spinner-border-sm"></span> Loading...
            </td>
          </tr>
        } @else if (periods.length === 0) {
          <tr>
            <td colspan="8" class="text-center text-muted">No period found.</td>
          </tr>
        } @else {
          @for (period of periods; track period.collectionPeriodId; let i = $index) {
            <tr>
              <td>{{ (pageNumber - 1) * resultsPerPage + i + 1 }}</td>
              <td>{{ period.collectionPeriodId }}</td>
              <td>{{ period.name }}</td>
              <td>{{ getCollectionName(period.collectionId) }}</td>
              <td>{{ period.startDateTimestamp !== 0 ? dateService.getDateFromatted(period.startDateTimestamp) : '-' }}</td>
              <td>{{ period.endDateTimestamp !== 0 ? dateService.getDateFromatted(period.endDateTimestamp) : '-' }}</td>
              <td>
                @switch (getPeriodStatus(period)) {
                  @case ('waiting') {
                    <span class="badge bg-info">Waiting</span>
                  }
                  @case ('in_progress') {
                    <span class="badge bg-success">In progress</span>
                  }
                  @case ('past') {
                    <span class="badge bg-danger">Past</span>
                  }
                }
              </td>
              <td>
                <button class="btn btn-sm btn-primary me-1" type="button" (click)="onClickEdit(period)" tooltip="Edit" placement="top"><i class="fa fa-edit"></i></button>
                <span class="text-muted mx-1">|</span>
                <button class="btn btn-sm btn-danger" type="button" (click)="onClickDelete(period)" tooltip="Delete" placement="top"><i class="fa fa-trash"></i></button>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
    <br/>
    <div class="d-flex justify-content-between align-items-center">
      <small class="text-muted">
        Showing {{ (pageNumber - 1) * resultsPerPage + 1 }} to {{ (pageNumber - 1) * resultsPerPage + periods.length }} of {{ totalResults }} entries
      </small>
      <ul class="pagination pagination-sm mb-0">
        <li class="page-item" [class.disabled]="pageNumber <= 1">
          <button class="page-link" (click)="onClickPaginationPrevious()" [disabled]="pageNumber <= 1">&laquo;</button>
        </li>
        @for (page of getPageNumbers(); track $index) {
          @if (page === null) {
            <li class="page-item disabled"><span class="page-link">...</span></li>
          } @else {
            <li class="page-item" [class.active]="page === pageNumber">
              <button class="page-link" (click)="goToPage(page)">{{ page }}</button>
            </li>
          }
        }
        <li class="page-item" [class.disabled]="pageNumber >= totalPages">
          <button class="page-link" (click)="onClickPaginationNext()" [disabled]="pageNumber >= totalPages">&raquo;</button>
        </li>
      </ul>
    </div>
  </div>
</div>

<app-collection-period-add-modal #addModal></app-collection-period-add-modal>
<app-collection-period-edit-modal #editModal></app-collection-period-edit-modal>
